import {
    FILTER_INVOICES,
    INVOICE_DETAIL_REQUEST_FAILED,
    INVOICE_DETAIL_REQUEST_STARTED,
    INVOICE_DETAIL_REQUEST_SUCCESS,
    INVOICE_LIST_CLOSE_NOTIFICATION, INVOICE_LIST_FORM_VALUE_CHANGED,
    INVOICE_LIST_REQUEST_FAILED,
    INVOICE_LIST_REQUEST_STARTED,
    INVOICE_LIST_REQUEST_SUCCESS,
    INVOICE_SETTING_REQUEST_FAILED,
    INVOICE_SETTING_REQUEST_STARTED,
    INVOICE_SETTING_REQUEST_SUCCESS,
} from './InvoiceListConstants'

export const invoiceListRequestStarted = () => {
    return {
        type: INVOICE_LIST_REQUEST_STARTED
    }
}

export const invoiceListRequestSuccess = (invoices) => {
    return {
        type: INVOICE_LIST_REQUEST_SUCCESS,
        payload: invoices
    }
}

export const invoiceListRequestFailed = (error) => {
    return {
        type: INVOICE_LIST_REQUEST_FAILED,
        payload: error
    }
}

export const invoiceSettingRequestStarted = () => {
    return {
        type: INVOICE_SETTING_REQUEST_STARTED
    }
}

export const invoiceSettingRequestSuccess = (setting) => {
    return {
        type: INVOICE_SETTING_REQUEST_SUCCESS,
        payload: setting
    }
}

export const invoiceSettingRequestFailed = (error) => {
    return {
        type: INVOICE_SETTING_REQUEST_FAILED,
        payload: error
    }
}

export const filterInvoices = (searchKey) => {

    return {
        type: FILTER_INVOICES,
        payload: searchKey
    }
}

export const closeNotificationClose = () => {
    return {
        type: INVOICE_LIST_CLOSE_NOTIFICATION
    }
}

export const invoiceDetailRequestStarted = () => {
    return {
        type: INVOICE_DETAIL_REQUEST_STARTED
    }
}

export const invoiceDetailRequestSuccess = (invoiceDetails) => {
    return {
        type: INVOICE_DETAIL_REQUEST_SUCCESS,
        payload: invoiceDetails
    }
}

export const invoiceDetailRequestFailed = (error) => {
    return {
        type: INVOICE_DETAIL_REQUEST_FAILED,
        payload: error
    }
}

export const formValueChanged = (nameValue) => {
    return {
        type: INVOICE_LIST_FORM_VALUE_CHANGED,
        payload: nameValue
    }
}




